import Styled from './styled'
import { useState } from 'react'
import { Col, DatePicker, Form, Row, Space, Typography, Spin } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import { ExportOutlined } from '@ant-design/icons'
import { useTranslate } from 'hooks/translate'
import _ from 'lodash'
import moment from 'utils/moment'
import { useMemo, useRef } from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { useEffect } from 'react'
import { incidentReport } from 'services/report'
import { exportIncidentApi } from 'services/incident'
import { dataURItoBlob } from 'utils/blob'
import { saveAs } from 'file-saver'
// Components
import Button from 'components/Button'
import Card from 'components/Card'
import FilterPeriodicitySelect from 'components/FilterPeriodicitySelect'
import IncidentTable from './components/incidentTable'
import IncidentBar from './components/IncidentBar'
import SearchOrganization from 'components/SearchOrganization'
import Select from 'components/Select'
import FilterReportStatusSelect from 'components/FilterReportStatusSelect'
import FilterReportTypeSelect from 'components/FilterReportTypeSelect'
import FilterRiskOwnerSelect from 'components/FilterRiskOwnerSelect'
import { toPng } from 'html-to-image'
const { RangePicker } = DatePicker
const DATE_FORMAT = 'YYYY-MM-DD'
export default function OperationalLossAndAppetite () {
  const {
    loading,
    incidentDashboard,
    incidentChart,
    incidentDashboardFilters,
    icPeriodFilter,
    icDateFilters,
    icReportTypeNumberFilters,
    icRemoveIncidentFilters,
  } = useStoreState((store) => store.monthlyDashboard)
  const {
    getIncidentChartThunk,
    getIncidentDashboardThunk,
    getReportDataTypeThunk,
    setIncidentDashboardFilters,
    setIcPeriodFilters,
    setIcDateFilters,
    setIcReportTypeNumberFilters,
    setIcRemoveIncidentFilters,
  } = useStoreActions((store) => store.monthlyDashboard)
  const [showHeader, setShowHeader] = useState(true)
  const [loadingPDF, setLoadingPDF] = useState(false)
  const [loadingExcel, setLoadingExcel] = useState(false)

  const { t } = useTranslate()
  const firstUpdate = useRef(true)
  const handleSubmit = (event) => {
    const [date_from, date_to] = event.date_from || []
    setIncidentDashboardFilters({
      ...incidentDashboardFilters,
      ...event,
      date_from: date_from?.format(DATE_FORMAT),
      date_to: date_to?.format(DATE_FORMAT),
    })
    getReportDataTypeThunk(event.report_type_id)
    clearSelector()
  }

  const clearSelector = () => {
    setIcDateFilters([])
    setIcPeriodFilters('monthly')
    setIcReportTypeNumberFilters([])
    setIcRemoveIncidentFilters([])
  }

  const data = useMemo(() => {
    // if (selectReportType) {
    const removeList = icRemoveIncidentFilters?.map((item) => item.value) || []

    const result = [
      ...incidentDashboard?.items?.filter((item) => {
        let filler = false
        //  filler = selectReportType ? item.reportTypes === selectReportType : true
        filler = !removeList.includes(item.reportHeaderId)
        return filler
      }),
    ]
    return {
      page: incidentDashboard.page,
      size: incidentDashboard.size,
      total: incidentDashboard.total,
      items: result,
    }
  }, [icRemoveIncidentFilters, incidentDashboard])

  const options = useMemo(() => {
    let result = []
    if (!_.isEmpty(incidentDashboard?.items)) {
      result = _.map(incidentDashboard.items, (item) => {
        return {
          label: item.incidentTopic,
          value: item.reportHeaderId,
          key: item.reportHeaderId,
        }
      })
      if (!_.isEmpty(icRemoveIncidentFilters)) {
        const temp = icRemoveIncidentFilters.map((item) => item.value)
        result = result.filter((item) => !temp.includes(item.value))
      }
    }
    return result
  }, [incidentDashboard, icRemoveIncidentFilters])

  const periodSelector = useMemo(() => {
    if (!_.isEmpty(incidentChart)) {
      const { data } = incidentChart
      return data[icPeriodFilter]?.map((item) => {
        return { label: item.period, value: item.period }
      })
    }
    return []
  }, [incidentChart, icPeriodFilter])

  const reportNumberAttrSelector = useMemo(() => {
    if (!_.isEmpty(incidentChart)) {
      const { keys } = incidentChart
      return keys?.map((item) => {
        return { label: item, value: item }
      })
    }
    return []
  }, [incidentChart])
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    // const risk_owner = convertOrganizationalStructureToFilters(incidentDashboardFilters.risk_owner_company_id)
    // incidentDashboardFilters.risk_owner_company_id = risk_owner?.company_id || [];
    getIncidentDashboardThunk(incidentDashboardFilters)
  }, [incidentDashboardFilters, getIncidentDashboardThunk])
  const exportExcel = async () => {
    const svg = document.getElementById('incidentBar')
    let dataURI = null
    if (!_.isEmpty(svg)) {
      dataURI = await toPng(svg, {
        backgroundColor: '#ffffff',
        width: svg.scrollWidth,
        height: svg.scrollHeight,
      })
    }
    if (dataURI !== null) {
      const blob = dataURItoBlob(dataURI)
      // const { data } = await incidentReport(
      //   {
      //     ...incidentDashboardFilters,
      //     exclude_incident: icRemoveIncidentFilters.map((item) => item.value),
      //   },
      //   blob
      // )
      await exportIncidentApi(_.omit({ ...incidentDashboardFilters }, 'page', 'size'), blob)
    }
    setLoadingExcel(false)
  }
  const handleExport = async () => {
    const svg = document.getElementById('incidentBar')
    let dataURI = null
    if (!_.isEmpty(svg)) {
      dataURI = await toPng(svg, {
        backgroundColor: '#ffffff',
        width: svg.scrollWidth,
        height: svg.scrollHeight,
      })
    }
    //TODO: ADD EXPORT LOGIC HERE

    if (dataURI !== null) {
      const blob = dataURItoBlob(dataURI)
      const { data } = await incidentReport(
        {
          ...incidentDashboardFilters,
          exclude_incident: icRemoveIncidentFilters.map((item) => item.value),
        },
        blob
      )
      if (data) {
        saveAs(data.file, data.filename)
      }
    }
    setLoadingPDF(false)
  }
  return (
    <Styled
      className='operational-loss-and-appetite-component'
      // style={{ minWidth: '800px', width: '1000px' }}
    >
      <Space size='middle' direction='vertical' style={{ width: '100%' }}>
        {showHeader ? (
          <Form
            layout='horizontal'
            colon={false}
            initialValues={{
              reporter_company_id: incidentDashboardFilters?.reporter_company_id,
              risk_co_company_id: incidentDashboardFilters?.risk_co_company_id,
              risk_owner_org: incidentDashboardFilters?.risk_owner_org,
              report_status_id: incidentDashboardFilters?.report_status_id,
              report_type_id: incidentDashboardFilters?.report_type_id,
              date_from: [
                incidentDashboardFilters?.date_from
                  ? moment(incidentDashboardFilters?.date_from)
                  : moment().startOf('year'),
                incidentDashboardFilters?.date_to
                  ? moment(incidentDashboardFilters?.date_to)
                  : moment(),
              ],
            }}
            name='search'
            onFinish={handleSubmit}
          >
            <Row gutter={8}>
              <Col span={22}>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item labelCol={{ span: 4 }} name='reporter_company_id' label='Reporter'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item name='risk_co_company_id' label='Risk Co'>
                      <SearchOrganization />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item name='risk_owner_org' labelCol={{ span: 4 }} label='Risk Owner'>
                      <FilterRiskOwnerSelect />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item name='date_from' label='Report From - to'>
                      <RangePicker allowClear={false} format={DATE_FORMAT} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={8}>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item
                      name='report_type_id'
                      labelCol={{ span: 4 }}
                      label='Report Type'
                      rules={[
                        {
                          required: true,
                          message: t('Please select report type'),
                        },
                      ]}
                    >
                      <FilterReportTypeSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Form.Item name='report_status_id'>
                      <FilterReportStatusSelect att={{ mode: 'multiple' }} />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={12}>
                    <Button
                      icon={<ExportOutlined />}
                      type='danger'
                      onClick={() => {
                        setLoadingPDF(true)
                        handleExport()
                      }}
                      loading={loadingPDF}
                    >
                      {t('Export PDF')}
                    </Button>
                  </Col> */}
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={2}>
                <Button type='primary' htmlType='submit'>
                  {t('Search')}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : null}
        <Row justify='end'>
          <Col>
            <Button
              onClick={() => setShowHeader(!showHeader)}
              icon={showHeader ? <UpOutlined /> : <DownOutlined />}
              type='link'
            >
              {showHeader ? 'Hide Filter' : 'Show Filter'}
            </Button>
          </Col>
        </Row>
        <Card
          style={{ minWidth: '800px', width: '800px' }}
          titleExtra={
            <Row justify='space-between' align='middle'>
              <Col>
                <Space size='middle'>
                  <Select
                    allowClear
                    mode='multiple'
                    dropdownMatchSelectWidth={false}
                    labelInValue
                    placeholder={t('Select Number Attributes')}
                    options={reportNumberAttrSelector}
                    filterOption={(input, option) => {
                      return option.label.includes(input)
                    }}
                    style={{ width: 200, textAlign: 'center' }}
                    value={icReportTypeNumberFilters}
                    onChange={(e) => {
                      setIcReportTypeNumberFilters(e)
                    }}
                  />
                </Space>
              </Col>
            </Row>
          }
          extra={
            <Col>
              <Space size='middle'>
                <FilterPeriodicitySelect
                  defaultValue={icPeriodFilter}
                  onChange={(e) => {
                    setIcPeriodFilters(e)
                    setIcDateFilters([])
                  }}
                />
                <Select
                  allowClear
                  mode='multiple'
                  dropdownMatchSelectWidth={false}
                  placeholder={t('')}
                  options={periodSelector}
                  value={icDateFilters}
                  style={{ width: 200, textAlign: 'center' }}
                  onChange={(e) => {
                    setIcDateFilters(e)
                  }}
                />
              </Space>
            </Col>
          }
        >
          <Spin spinning={loading}>
            <IncidentBar
              dataSource={incidentChart}
              reportAttr={icReportTypeNumberFilters}
              period={icPeriodFilter}
              selectDateTime={icDateFilters}
            />
          </Spin>
          <Space direction='horizontal' style={{ width: '100%', justifyContent: 'center' }}>
            <div className='container-remove'>
              <div className='wrapper'>
                <Typography.Text>
                  {t('Remove Incident ')}
                  <br />
                </Typography.Text>
              </div>
              <div className='wrapper'>
                <Select
                  allowClear
                  mode='multiple'
                  labelInValue
                  placeholder={t('')}
                  options={options}
                  filterOption={(input, option) => {
                    return option.label.includes(input)
                  }}
                  value={icRemoveIncidentFilters}
                  onChange={(e) => {
                    getIncidentChartThunk({
                      ...incidentDashboardFilters,
                      exclude_incident: _.map(e, (item) => item.value),
                    })
                    setIcRemoveIncidentFilters(e)
                  }}
                  style={{ width: 400, textAlign: 'center' }}
                ></Select>
              </div>
            </div>
          </Space>
        </Card>
        <Card
          title={t('Incident Report')}
          titleExtra={
            <Col>
              <Space size='middle'>
                <Button
                  className=''
                  type='primary'
                  shape='round'
                  onClick={() => {
                    setLoadingExcel(true)
                    exportExcel()
                  }}
                  loading={loadingExcel}
                >
                  {t('Export Excel')}
                </Button>
              </Space>
            </Col>
          }
        >
          <IncidentTable
            loading={loading}
            dataSource={data}
            filters={incidentDashboardFilters}
            onChange={(pagination) => {
              setIncidentDashboardFilters({
                ...incidentDashboardFilters,
                page: pagination.current,
                size: pagination.pageSize,
              })
            }}
          />
        </Card>
      </Space>
    </Styled>
  )
}
